module.exports = __webpack_public_path__ + "media/images/logo_digibtw-08572425ed1645df86056ca3ce11b9a1.svg";